import { Component } from '@angular/core';

@Component({
  selector: 'td-wb-input-group-note',
  templateUrl: 'input-group-note.component.html',
  styleUrls: ['input-group-note.component.scss']
})
export class InputGroupNoteComponent {
}
